import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';

function CopilotResponseView({ message='' }) {

  return (
    // min-w-0 lets this shrink below its min-content width (it is the bubble's only
    // flex child, and flex items default to min-width:auto). w-full keeps it filling
    // the bubble once the bubble itself is sized to fit.
    <div className="prose max-w-none min-w-0 w-full copilot-response-view">
      <ReactMarkdown
        children={message}
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw, rehypeSanitize]}
      />
    </div>
  );
}

export default CopilotResponseView;